<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1>Daily tasks</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div>
          <h3>Populate DifferentTech declined leads information</h3>
          <p>Only CSV documents allowed</p>
          <div class="pb-6">
            <a
              href="/example_files/declined_leads_example.csv"
              download="declined_leads_example.csv"
              >View example of file to upload</a
            >
          </div>
          <v-file-input
            v-model="file"
            single-line
            outlined
            dense
            filled
            :loading="buttonLoading"
            label="Upload file"
            class="file-upload-btn"
          />
        </div>
        <v-btn
          rounded
          depressed
          :loading="buttonLoading"
          color="primary"
          @click="uploadLeadIdsFile()"
          ><span>Upload</span></v-btn
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div>
          <h3>Download monthly death check list</h3>
        </div>

        <v-btn
          rounded
          depressed
          :loading="deathCheckListButtonLoading"
          :disabled="isNewestDeathCheckListProcessing"
          color="primary"
          @click="downloadMonthlyDeathCheckList()"
          ><span>Generate new file</span></v-btn
        >
      </v-col>
    </v-row>
    <div style="display: flex; flex-direction: column">
      <a
        @click="list.processing ? null : downloadDeathCheckList(list.id)"
        v-for="list in deathCheckLists"
        :key="list.id"
        >{{ list.processing ? 'Processing' : `${list.fileName}.csv` }}</a
      >
      <br />
    </div>
    <v-row>
      <v-col cols="12" class="mt-3">
        <v-row>
          <v-col cols="12">
            <h3>Populate testator basic info by RSA ID or Testator ID</h3>
            <p>Only CSV documents allowed</p>
            <v-file-input
              v-model="testatorIDsFile"
              single-line
              outlined
              dense
              filled
              :loading="testatorIDsButtonLoading"
              label="Upload file"
              class="file-upload-btn"
            />
          </v-col>
        </v-row>
        <v-row class="align-center">
          <v-col xl="2" lg="2" md="3" sm="12">
            <v-btn
              rounded
              depressed
              :loading="testatorIDsButtonLoading"
              color="primary"
              @click="uploadTestatorIdsFile('rsa_id')"
              :disabled="!this.testatorIDsFile"
              class="upload-button"
              ><span>Upload RSA Ids</span></v-btn
            >
          </v-col>
          <v-col xl="2" lg="2" md="4">
            <a
              href="/example_files/testator_rsa_id.csv"
              download="testator_rsa_id.csv"
              >View example of file to upload RSA ID</a
            >
          </v-col>
        </v-row>
        <v-row class="align-center">
          <v-col xl="2" lg="2" md="3" sm="12">
            <v-btn
              rounded
              depressed
              :loading="testatorIDsButtonLoading"
              color="primary"
              @click="uploadTestatorIdsFile('id')"
              :disabled="!this.testatorIDsFile"
              class="upload-button"
              ><span>Upload Testator Ids</span></v-btn
            >
          </v-col>
          <v-col xl="2" lg="2" md="4" sm="12">
            <a href="/example_files/testator_id.csv" download="testator_id.csv"
              >View example of file to upload testator ID</a
            >
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="mt-10 flex-column">
      <v-col cols="3" v-for="tbil in testatorBasicInfoLists" :key="tbil.id">
        <a
          @click="
            tbil.processing ? null : downloadTestatorBasicInfoList(tbil.id)
          "
          >{{ tbil.processing ? 'Processing' : `${tbil.fileName}.csv` }}</a
        >
      </v-col>
    </v-row>

    <UploadExternalLeadList
      exampleFileHref="/example_files/death_check_example.xlsx"
      exampleFileName="death_check_example.xlsx"
      title="Death Check List"
      subtitle="Upload death check list to mark testators as deceased"
      type="UploadDeathCheckListBatchJob"
    />
    <IwyzeUploadCampaignLeads />

    <UploadExternalLeadList
      exampleFileHref="/example_files/iwyze_rather_chat_example.xlsx"
      exampleFileName="iwyze_rather_chat_example.xlsx"
      title="Upload iWyze max attempt leads"
      subtitle="Upload list of iWyze leads to be added to Rather.Chat"
      type="IwyzeRatherChatBatchJob"
    />
    <DownloadList
      title="Download Smart Goals List"
      subtitle="Download list of Testators and their statuses"
      type="SmartGoalsReportBatchJob"
    />
    <ProductSaleTracking />
    <PopulateIdentityNumbers />
    <SeedPfAdviserRegionalData />
    <CompanyLeadMigration />
    <TriggerDailyTaskTest />
  </v-container>
</template>

<script>
  import {
    UPLOAD_LEAD_IDS_MUTATION,
    DOWNLOAD_MONTHLY_DEATH_CHECK_LIST_MUTATION,
    FETCH_MONTHLY_DEATH_CHECK_LISTS_MUTATION,
    FETCH_UPLOADED_DEATH_CHECK_LIST_MUTATION,
    UPLOAD_TESTATOR_IDS_MUTATION,
    FETCH_TESTATOR_BASIC_INFO_LISTS_MUTATION,
    FETCH_UPLOADED_TESTATOR_BASIC_INFO_LIST_MUTATION,
  } from '../../constants/graphql/daily-tasks';
  import PopulateIdentityNumbers from './PopulateIdentityNumbers.vue';
  import ProductSaleTracking from './ProductSaleTracking.vue';
  import IwyzeUploadCampaignLeads from './IwyzeUploadCampaignLeads.vue';
  import UploadExternalLeadList from './UploadExternalLeadList.vue';
  import TriggerDailyTaskTest from './TriggerDailyTaskTest.vue';
  import moment from 'moment';
  import TestOmiPay from './TestOmiPay.vue';
  import DownloadList from './DownloadList.vue';
  import CompanyLeadMigration from './CompanyLeadMigration.vue';
  import SeedPfAdviserRegionalData from './SeedPfAdviserRegionalData.vue';
  export default {
    name: 'DailyTasksPage',
    components: {
      ProductSaleTracking,
      PopulateIdentityNumbers,
      TriggerDailyTaskTest,
      TestOmiPay,
      IwyzeUploadCampaignLeads,
      UploadExternalLeadList,
      DownloadList,
      CompanyLeadMigration,
      SeedPfAdviserRegionalData,
    },
    data() {
      return {
        file: null,
        deathCheckFile: null,
        testatorIDsFile: null,
        buttonLoading: false,
        deathCheckListButtonLoading: false,
        returnedLeadIdsValue: null,
        deathCheckLists: [],
        intervalId: null,
        testatorIDsButtonLoading: null,
        testatorBasicInfoLists: [],
      };
    },
    computed: {
      isNewestDeathCheckListProcessing() {
        return (
          this.deathCheckLists.length > 0 && this.deathCheckLists[0].processing
        );
      },
    },
    created() {
      this.intervalId = setInterval(this.fetchMonthlyDeathCheckLists, 5000);
      this.testatorBasicInfoListIntervalId = setInterval(
        this.fetchTestatorBasicInfoLists,
        7777
      );
      this.fetchMonthlyDeathCheckLists();
      this.fetchTestatorBasicInfoLists();
    },
    methods: {
      uploadDeathCheckFile() {
        if (this.deathCheckFile) {
          this.buttonLoading = true;
          var reader = new FileReader();
          reader.readAsDataURL(this.deathCheckFile);
          reader.onload = function (evt) {
            const fileBase64 = evt.target.result;
            this.uploadDeathChecks(fileBase64);
          }.bind(this);
        }
      },
      uploadDeathChecks(fileBase64) {
        const testatorId = this.$store.getters.testatorId;
        this.$apollo
          .mutate({
            mutation: UPLOAD_LEAD_IDS_MUTATION,
            variables: {
              testatorId,
              fileBase64,
            },
          })
          .then(_response => {
            this.returnedLeadIdsValue = _response.data.uploadLeadIds.fileBase64;
            this.downloadFile(this.returnedLeadIdsValue);
            this.buttonLoading = false;
            this.file = null;
          })
          .catch(error => {
            this.file = null;
          });
      },

      uploadLeadIdsFile() {
        if (this.file) {
          this.buttonLoading = true;
          var reader = new FileReader();
          reader.readAsDataURL(this.file);
          reader.onload = function (evt) {
            const fileBase64 = evt.target.result;
            this.uploadLeadIds(fileBase64);
          }.bind(this);
        }
      },
      uploadTestatorIdsFile(idType) {
        this.testatorIDsButtonLoading = true;
        var reader = new FileReader();
        reader.readAsDataURL(this.testatorIDsFile);
        reader.onload = function (evt) {
          const fileBase64 = evt.target.result;
          this.uploadTestatorIds(idType, fileBase64);
        }.bind(this);
      },
      downloadMonthlyDeathCheckList() {
        this.deathCheckListButtonLoading = true;
        const testatorId = this.$store.getters.testatorId;

        this.$apollo
          .mutate({
            mutation: DOWNLOAD_MONTHLY_DEATH_CHECK_LIST_MUTATION,
            variables: {
              testatorId,
            },
          })
          .then(_response => {
            this.deathCheckLists = _response.data.downloadMonthlyDeathCheckList;
            this.deathCheckListButtonLoading = false;
          })
          .catch(error => {
            this.deathCheckListButtonLoading = false;
            this.file = null;
          });
      },
      fetchMonthlyDeathCheckLists() {
        const testatorId = this.$store.getters.testatorId;

        this.$apollo
          .mutate({
            mutation: FETCH_MONTHLY_DEATH_CHECK_LISTS_MUTATION,
            variables: {
              testatorId,
            },
          })
          .then(_response => {
            this.deathCheckLists = _response.data.fetchMonthlyDeathCheckLists;
            this.deathCheckListButtonLoading = false;
          })
          .catch(error => {
            this.deathCheckListButtonLoading = false;
            this.file = null;
          });
      },
      fetchTestatorBasicInfoLists() {
        this.$apollo
          .mutate({
            mutation: FETCH_TESTATOR_BASIC_INFO_LISTS_MUTATION,
          })
          .then(_response => {
            this.testatorBasicInfoLists =
              _response.data.fetchTestatorBasicInfoLists;
            this.testatorIDsButtonLoading = false;
          })
          .catch(error => {
            this.testatorIDsButtonLoading = false;
            this.testatorIDsFile = null;
          });
      },
      downloadDeathCheckList(deathCheckListId) {
        const testatorId = this.$store.getters.testatorId;

        this.$apollo
          .mutate({
            mutation: FETCH_UPLOADED_DEATH_CHECK_LIST_MUTATION,
            variables: {
              testatorId,
              deathCheckListId,
            },
          })
          .then(_response => {
            const url = _response.data.fetchUploadedDeathCheckList.url;
            window.open(url, '_blank');
          })
          .catch(error => {});
      },
      downloadTestatorBasicInfoList(testatorBasicInfoListId) {
        this.$apollo
          .mutate({
            mutation: FETCH_UPLOADED_TESTATOR_BASIC_INFO_LIST_MUTATION,
            variables: {
              testatorBasicInfoListId,
            },
          })
          .then(_response => {
            const url = _response.data.fetchUploadedTestatorBasicInfoList.url;
            window.open(url, '_blank');
          })
          .catch(error => {});
      },
      downloadFile(file) {
        const link = document.createElement('a');
        const blob = this.base64ToBlob(file, 'text/csv');
        const url = URL.createObjectURL(blob);
        const filename = `${moment(new Date()).format(
          'DD-MM-YYYY'
        )}_declined_leads_information`;
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      },
      base64ToBlob(base64, mimeType) {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: mimeType });
      },
      uploadLeadIds(fileBase64) {
        const testatorId = this.$store.getters.testatorId;
        this.$apollo
          .mutate({
            mutation: UPLOAD_LEAD_IDS_MUTATION,
            variables: {
              testatorId,
              fileBase64,
            },
          })
          .then(_response => {
            this.returnedLeadIdsValue = _response.data.uploadLeadIds.fileBase64;
            this.downloadFile(this.returnedLeadIdsValue);
            this.buttonLoading = false;
            this.file = null;
          })
          .catch(error => {
            this.file = null;
          });
      },

      uploadTestatorIds(idType, fileBase64) {
        this.testatorIDsButtonLoading = true;
        this.$apollo
          .mutate({
            mutation: UPLOAD_TESTATOR_IDS_MUTATION,
            variables: {
              idType,
              fileBase64,
            },
          })
          .then(_response => {
            this.testatorBasicInfoLists = _response.data.uploadTestatorIds;
            this.testatorIDsFile = null;
          })
          .catch(error => {
            this.testatorIDsFile = null;
            this.testatorIDsButtonLoading = false;
          });
      },
    },
    beforeDestroy() {
      clearInterval(this.intervalId);
      clearInterval(this.testatorBasicInfoListIntervalId);
    },
    apollo: {},
  };
</script>
